import React, { useEffect, useState } from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/Roles/AttributeMappingTableFields.json";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../Common/Permission";
import { Pill } from "../../../constants/assets/containers";
import * as AttributeMapping from "../../../store/actions/AttributeMapping";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const AttributeMappingList = (props) => {
  const {
    attributeMappingList = [],
    handleClick,
    handleToggleUpdate,
    editState,
    setEditState,
    initialActionType,
  } = props;
  const tableFields = TableFields;
  const allActions = MenuActionsMappings[MenuNames.ATTRIBUTE_MAPPING];
  const [enableClicked, setEnableClicked] = useState(false);

  useEffect(() => {
    if (enableClicked) {
      handleToggleUpdate(editState);
      setEnableClicked(false);
    }
  }, [editState, enableClicked]);

  const convertTime = (
    restrictedPeriod = [{ start_time: "", end_time: "" }]
  ) => {
    const formattedPeriods = restrictedPeriod.map(
      ({ start_time = "", end_time = "" }) => {
        start_time = formatTime(start_time);
        end_time = formatTime(end_time);
        return { start_time, end_time };
      }
    );
    while (formattedPeriods.length < 3) {
      formattedPeriods.push({ start_time: "", end_time: "" });
    }
    return formattedPeriods;
  };

  const formatPeakPeriod = (peakPeriod = "") => {
    if (!peakPeriod) return "";

    const formattedPeriods = peakPeriod
      .map(({ start_time, end_time }) => {
        const formattedStart = formatTime(start_time);
        const formattedEnd = formatTime(end_time);
        if (!!formattedStart && !!formattedEnd) {
          return `${formattedStart} to ${formattedEnd}`;
        }
        return "";
      })
      .filter((val) => !!val);

    if (formattedPeriods.length > 0) {
      return formattedPeriods.join(", ");
    }

    return "";
  };

  const setCurrentState = (data) => {
    const updatedEditState = { ...editState };
    updatedEditState.action = initialActionType;
    updatedEditState.attribute_type = data.attribute_type;
    updatedEditState.attribute_value = data.attribute_value;
    const convertedRestrictedPeriod = convertTime(data.restricted_period ?? []);
    updatedEditState.restricted_period = convertedRestrictedPeriod.map(
      (item) => item
    );
    updatedEditState.enabled = data.enabled;

    setEditState(updatedEditState);
  };

  const handleEditClick = (data) => {
    setCurrentState(data);
    handleClick("Edit");
  };

  const handleEnableClick = (data) => {
    setCurrentState(data);
    setEnableClicked(true);
  };

  const formatTime = (time = "") => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${formattedHour}:${minute} ${period}`;
  };

  const getFieldValue = (attributeMapping, key) => {
    switch (key) {
      case "action":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE]}
            notAllowedText="No Actions Permitted"
          >
            <span
              onClick={() => handleEditClick(attributeMapping)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "restricted_period":
        return formatPeakPeriod(attributeMapping[key]);
      case "enabled":
        return (
          <div className="flex items-center">
            <Pill className="mr-6" isFalse={!attributeMapping[key]}>
              {attributeMapping[key] ? "Yes" : "No"}
            </Pill>
            <Permission
              requiredPerms={[allActions.UPDATE]}
              notAllowedText="No Actions Permitted"
            >
              <span
                onClick={() => handleEnableClick(attributeMapping)}
                className={"edit-options cursor-pointer"}
              >
                {attributeMapping[key] ? "Disable" : "Enable"}
              </span>
            </Permission>
          </div>
        );
      default:
        return attributeMapping[key];
    }
  };

  return (
    <Permission requiredPerms={[allActions.LIST]}>
      <Table
        list={attributeMappingList}
        getFieldValue={getFieldValue}
        fields={tableFields}
      />
    </Permission>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAttributeMapping: bindActionCreators(
      dispatch,
      AttributeMapping.updateAttributeMapping
    ),
  };
};

const mapStateToProps = (state) => {
  const { attributeMapping = {} } = state;
  return {
    userId: attributeMapping.userId || 0,
  };
};

export default connect(
  mapDispatchToProps,
  mapStateToProps
)(AttributeMappingList);
